import { Component, ViewChild, ViewEncapsulation, OnInit, ElementRef } from '@angular/core';

import { WjInputDate } from '@grapecity/wijmo.angular2.input';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1900Model } from './kymw1900.model';
import { KYMW1900InputModel } from './vo/kymw1900-input.model';
import { KYMW1900OutputModel } from './vo/kymw1900-output.model';

/**
 * 組合員の声検索画面を管理するクラス
 *
 * @export KYMW1900Component
 * @class KYMW1900Component
 */
@Component({
  selector: 'app-kymw1900',
  templateUrl: 'kymw1900.component.html',
  styleUrls: ['kymw1900.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1900Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtf_ReceiptDateFrom', { static: true }) dtf_ReceiptDateFrom: WjInputDate;
  @ViewChild('dtf_ReceiptDateTo', { static: true }) dtf_ReceiptDateTo: WjInputDate;
  @ViewChild('dtf_ImportDateFrom', { static: true }) dtf_ImportDateFrom: WjInputDate;
  @ViewChild('dtf_ImportDateTo', { static: true }) dtf_ImportDateTo: WjInputDate;

  /**  親画面への連携値 */
  public setKYMW1900Parameter: Function;

  /** モデル */
  public kymw1900Model: KYMW1900Model = new KYMW1900Model();

  /** ウィンドウを閉じる際の処理 */
  public closeFunction: Function;

  /**
   * コンストラクタ
   * @param {PlessDialogServiceSub} dialogService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1900Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW1900InputVO
   */
  public setInterfaceParam(inputVO: KYMW1900InputModel): void {
    this.kymw1900Model.receiptNumFrom = inputVO.receiptNumFrom;
    this.kymw1900Model.receiptNumTo = inputVO.receiptNumTo;
    this.kymw1900Model.classCode = inputVO.classCode;
    this.kymw1900Model.subject = inputVO.subject;
    this.kymw1900Model.inquiryContents = inputVO.inquiryContents;
    this.kymw1900Model.receiptDateFrom = inputVO.receiptDateFrom;
    this.kymw1900Model.receiptDateTo = inputVO.receiptDateTo;
    this.kymw1900Model.publishType = inputVO.publishType;
    this.kymw1900Model.coopCode = inputVO.coopCode;
    this.kymw1900Model.importDateFrom = inputVO.importDateFrom;
    this.kymw1900Model.importDateTo = inputVO.importDateTo;
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1900Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1900';
  }

  /**
   * 検索ボタン押下時に呼び出されるメソッド。
   */
  public eventSearchHandler(): void {
    // view入力項目のチェック
    if (!this.checkViewInput()) {
      return;
    }

    // KYMW1900OutputVOを生成し、呼出元に返す
    this.setKYMW1900Parameter(this.createKYMW1900OutputVO());

    // 閉じる処理
    this.closeFunction();

  }

  /**
   * view入力項目のチェックメソッド。
   *
   * @return チェック結果
   */
  private checkViewInput(): boolean {
    // 検索条件入力チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw1900Model.receiptNumFrom) && PlessViewUtilsSub.isEmpty(this.kymw1900Model.receiptNumTo)
      && PlessViewUtilsSub.isEmpty(this.kymw1900Model.classCode) && PlessViewUtilsSub.isEmpty(this.kymw1900Model.subject)
      && PlessViewUtilsSub.isEmpty(this.kymw1900Model.inquiryContents) && PlessViewUtilsSub.isEmpty(this.kymw1900Model.publishType)
      && PlessViewUtilsSub.isEmpty(this.dtf_ReceiptDateFrom.text) && PlessViewUtilsSub.isEmpty(this.dtf_ReceiptDateTo.text)
      && PlessViewUtilsSub.isEmpty(this.dtf_ImportDateFrom.text) && PlessViewUtilsSub.isEmpty(this.dtf_ImportDateTo.text)
      && PlessViewUtilsSub.isEmpty(this.kymw1900Model.coopCode)) {

      this.dialogService.openAlertGetMessage('E0143', []);
      return false;
    }

    // 受付番号の相関チェック
    if ((PlessViewUtilsSub.isEmpty(this.kymw1900Model.receiptNumFrom) && !PlessViewUtilsSub.isEmpty(this.kymw1900Model.receiptNumTo))
      || (!PlessViewUtilsSub.isEmpty(this.kymw1900Model.receiptNumFrom) && PlessViewUtilsSub.isEmpty(this.kymw1900Model.receiptNumTo))
      || this.kymw1900Model.receiptNumFrom > this.kymw1900Model.receiptNumTo) {

      this.dialogService.openAlertGetMessage('E0123', ['受付番号']);
      return false;
    }

    // 会員受付日（開始）の入力チェック
    if (PlessViewUtilsSub.isEmpty(this.dtf_ReceiptDateFrom.text) && !PlessViewUtilsSub.isEmpty(this.dtf_ReceiptDateTo.text)) {
      this.dialogService.openAlertGetMessage('E0113', ['会員受付日の範囲入力']);
      return false;
    }

    // 会員受付日の相関チェック
    if (this.dtf_ReceiptDateFrom.text > this.dtf_ReceiptDateTo.text) {
      this.dialogService.openAlertGetMessage('E0123', ['会員受付日']);
      return false;
    }

    // PEACE取込日（開始）の入力チェック
    if (PlessViewUtilsSub.isEmpty(this.dtf_ImportDateFrom.text) && !PlessViewUtilsSub.isEmpty(this.dtf_ImportDateTo.text)) {
      this.dialogService.openAlertGetMessage('E0113', ['PEACE取込日の範囲入力']);
      return false;
    }

    // PEACE取込日の相関チェック
    if (this.dtf_ImportDateFrom.text > this.dtf_ImportDateTo.text) {
      this.dialogService.openAlertGetMessage('E0123', ['PEACE取込日']);
      return false;
    }

    return true;
  }

  /**
   * 呼び出し元画面に返却する情報を格納するVO生成メソッド。
   *
   * @return 親画面返却VO
   */
  private createKYMW1900OutputVO(): KYMW1900OutputModel {

    // 日付 バインドされなのでModelに詰める
    this.kymw1900Model.receiptDateFrom = this.dtf_ReceiptDateFrom.text;
    this.kymw1900Model.receiptDateTo = this.dtf_ReceiptDateTo.text;
    this.kymw1900Model.importDateFrom = this.dtf_ImportDateFrom.text;
    this.kymw1900Model.importDateTo = this.dtf_ImportDateTo.text;

    // 呼び出し元へ帰すVOを作成
    const outputVO: KYMW1900OutputModel = new KYMW1900OutputModel();
    outputVO.receiptDateFrom = this.kymw1900Model.receiptDateFrom;
    outputVO.receiptDateTo = this.kymw1900Model.receiptDateTo;
    outputVO.importDateFrom = this.kymw1900Model.importDateFrom;
    outputVO.importDateTo = this.kymw1900Model.importDateTo;
    outputVO.classCode = this.kymw1900Model.classCode;
    outputVO.subject = this.kymw1900Model.subject;
    outputVO.inquiryContents = this.kymw1900Model.inquiryContents;
    outputVO.receiptNumFrom = this.kymw1900Model.receiptNumFrom;
    outputVO.receiptNumTo = this.kymw1900Model.receiptNumTo;
    outputVO.publishType = this.kymw1900Model.publishType;
    outputVO.coopCode = this.kymw1900Model.coopCode;
    return outputVO;
  }

}
